import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { editCategory } from '../../api/products';

export default function DisableCategory({
  category,
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [error, setError] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [categoryData, setCategoryData] = useState({});
  const [isActive, setIsActive] = useState(null);
  useEffect(() => {
    setCategoryData({ ...category });
    setIsActive(category.status === 'active' ? true : false);
  }, [category]);

  const handleSubmit = useCallback(async () => {
    try {
      const updatedStatus = isActive ? 'inactive' : 'active';
      const updatedcategory = { status: updatedStatus };
      let response = await editCategory(categoryData.id, updatedcategory, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      fetchData();
      setMessage(`category  ${isActive ? 'removed' : 'restored'} successfully`);
      setSnackbarOpen(true);
    } catch (error) {
      setError(`Failed to ${isActive ? 'remove' : 'restore'} the category`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, isActive]);

  const handleButtonClick = () => {
    setConfirmationOpen(true);
  };

  const handleConfirm = () => {
    handleSubmit();
    setConfirmationOpen(false);
  };

  const handleCancel = () => {
    setConfirmationOpen(false);
  };

  return (
    <>
      {isActive ? (
        <Button
          variant="text"
          sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
          onClick={handleButtonClick}>
          Remove category
        </Button>
      ) : (
        <Button
          variant="text"
          sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
          onClick={handleButtonClick}>
          Restore category
        </Button>
      )}
      <Dialog
        open={confirmationOpen}
        onClose={handleCancel}
        fullWidth
        maxWidth="sm">
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to{' '}
            {isActive ? 'remove' : 'restore'} category{' '}
            <strong>"{category.name}"</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="secondary">
            {isActive ? 'Remove' : 'Restore'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
